import React from 'react';
import Drawer from 'material-ui/Drawer';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import MenuItem from 'material-ui/MenuItem';
import Menu from 'material-ui/Menu';
import Divider from 'material-ui/Divider';
import { push } from 'react-router-redux';
import PersonAdd from 'material-ui/svg-icons/social/person-add';
import ActionAccountBalance from 'material-ui/svg-icons/action/account-balance';
import ActionLightBulbOutline from 'material-ui/svg-icons/action/lightbulb-outline';
import ActionTimeline from 'material-ui/svg-icons/action/timeline';
import ActionInfoOutline from 'material-ui/svg-icons/action/info-outline';
import BusinessCenter from 'material-ui/svg-icons/places/business-center';
import ActionGavelfrom from 'material-ui/svg-icons/action/gavel';


import Paper from 'material-ui/Paper';
import './../../index.css';
import { changedUiDrawerVisibility } from '../../actions/index';
import { store } from '../../index';

const style = {
  paper: {
    display: 'inline-block',
    float: 'left',
    margin: '16px 32px 16px 5px',
    //width: '250px',
  },


}
class AppDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.handleToggle = this.handleToggle.bind(this);
  }

  handleToggle() {
    this.props.changedUiDrawerVisibility(!this.props.uiState.drawerVisibile);
  }
  handleCloseMenue1 = () => {
    this.props.changedUiDrawerVisibility(false);
    store.dispatch(push('/prozesskostenrechner'));
  }
  handleCloseMenue2 = () => {
    this.props.changedUiDrawerVisibility(false);
    store.dispatch(push('/about'));
  }
  handleCloseMenue3 = () => {
    this.props.changedUiDrawerVisibility(false);
    store.dispatch(push('/verzugszinsen-berechnen'));
  }

  handleCloseMenue4 = () => {
    this.props.changedUiDrawerVisibility(false);
    store.dispatch(push('/'));
  }



  handeleCloseAndPush(path) {
    this.props.changedUiDrawerVisibility(false);
    store.dispatch(push(path));
  }

  render() {
    return (
      <div>
        <Drawer


          open={this.props.uiState.drawerVisibile}
          onClick={() => { this.handleToggle(); }}
          >
          <Paper style={style.paper}>
            <Menu>
              <MenuItem
                onClick={this.handleCloseMenue1}
                primaryText="Anwaltskostenrechner"
                leftIcon={<ActionGavelfrom />}
                style={{width:'230px'}}
                />
                <a href='https://www.prinz.law/verzugszinsen-berechnen'>
              <MenuItem
                onClick={this.handleCloseMenue3}
                primaryText="Verzugszinsen"
                leftIcon={<ActionTimeline />}
                style={{width:'230px'}}
                />
                </a>
           
              <a href='https://www.prinz.law/kautions-zins'>
                <MenuItem
                  primaryText="Kautionszinsen"
                  leftIcon={<ActionAccountBalance />}
                  style={{width:'230px'}}
                />
              </a>

              <a href='https://appsource.microsoft.com/de-de/product/office/WA104381005?src=office&tab=Overview'>
                <MenuItem
                  primaryText="Word-Add-In 'Legal'"
                  leftIcon={<ActionLightBulbOutline />}
                  style={{width:'230px'}}
                />
              </a>
              <Divider />
              <a href="https://www.prinz.law/">
                <MenuItem
                  primaryText="Kanzlei"
                  leftIcon={<BusinessCenter />}
                  style={{width:'230px'}}
                  />
                  </a>
              <MenuItem
                onClick={this.handleCloseMenue2}
                primaryText="Impressum"
                leftIcon={<ActionInfoOutline />}
                style={{width:'230px'}}
                />
                <MenuItem
                  onClick={this.handleCloseMenue2}
                  primaryText="Datenschutz"
                  leftIcon={<PersonAdd />}
                  style={{width:'230px'}}
                  />

            </Menu>
          </Paper>
        </Drawer>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    uiState: state.uiState,
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators({
    changedUiDrawerVisibility,
  }, dispatch);
}
export default connect(mapStateToProps, matchDispatchToProps)(AppDrawer);



// WEBPACK FOOTER //
// ./src/containers/elements/AppDrawer.jsx